module.exports = __webpack_public_path__ + "c555ed950f762510237e74fc995151e9.otf";